module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box"
  }, [_c('el-form', {
    ref: "ruleForm",
    staticClass: "demo-ruleForm login-container",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "model": _vm.ruleForm,
      "rules": _vm.rules,
      "label-position": "left",
      "label-width": "0px"
    }
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v("扫吧AR 经销商密码更改")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "phone"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "prefix-icon": "el-icon-phone",
      "auto-complete": "off",
      "clearable": "",
      "placeholder": "请输入账号绑定手机号"
    },
    model: {
      value: (_vm.ruleForm.phone),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "phone", $$v)
      },
      expression: "ruleForm.phone"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append"
    },
    nativeOn: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.handleSendPhone($event)
      }
    },
    slot: "append"
  }, [_vm._v("发送")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "password"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "prefix-icon": "el-icon-warning",
      "clearable": "",
      "auto-complete": "off",
      "placeholder": "请输入新密码"
    },
    model: {
      value: (_vm.ruleForm.password),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "password", $$v)
      },
      expression: "ruleForm.password"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "password2"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "prefix-icon": "el-icon-warning",
      "clearable": "",
      "auto-complete": "off",
      "placeholder": "请再次输入新密码"
    },
    model: {
      value: (_vm.ruleForm.password2),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "password2", $$v)
      },
      expression: "ruleForm.password2"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "code"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "prefix-icon": "el-icon-warning",
      "clearable": "",
      "auto-complete": "off",
      "placeholder": "请输入手机收到的验证码"
    },
    model: {
      value: (_vm.ruleForm.code),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "code", $$v)
      },
      expression: "ruleForm.code"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.handleSubmit($event)
      }
    }
  }, [_vm._v("保存")])], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.handleReturn($event)
      }
    }
  }, [_vm._v("返回")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-23a6abfa"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Passwd.vue
// module id = 1035
// module chunks = 1